'use client';

// #region IMPORT
import { Box, Stack, Button, Container, Typography } from '@mui/material';

import { useResponsive } from 'src/hooks/use-responsive';

import { Iconify, APP_ICONS } from 'src/components/iconify';
// #endregion

export const Sercurity = () => {
  const smUp = useResponsive('up', 'sm');
  const mdUp = useResponsive('up', 'md');
  return (
    <Box
      position="relative"
      zIndex={1}
      py={{ xs: 8, sm: 4, md: 5 }}
      sx={{
        bgcolor: 'background.paper',
        textAlign: 'center',
        overflow: 'hidden',
      }}
    >
      <Container sx={{ position: 'relative' }}>
        <Stack direction="row" width={1}>
          <Stack width={1} spacing={smUp ? 5 : 4}>
            <Stack spacing={2}>
              <Typography textAlign={smUp ? 'unset' : 'center'} fontWeight="medium">
                Ưu tiên hàng đầu
              </Typography>
              <Stack alignItems={smUp ? 'unset' : 'center'} spacing={smUp ? 2.5 : 4}>
                <Typography variant="h2" fontWeight="bold">
                  Bảo mật dữ liệu
                </Typography>
                <Stack textAlign="center">
                  <Typography>Đảm bảo tính toàn vẹn và bảo mật của dữ liệu của bạn</Typography>
                  <Typography>là điều quan trọng nhất đối với chúng tôi.</Typography>
                </Stack>
                <Box>
                  <Button
                    endIcon={<Iconify icon={APP_ICONS.navigation.forward} />}
                    variant="contained"
                    sx={{
                      px: smUp ? 3 : 2,
                      bgcolor: 'grey.300',
                      color: 'text.primary',
                      '&:hover': {
                        bgcolor: 'grey.400',
                      },
                    }}
                    href="/policy/privacy"
                    target="_blank"
                  >
                    Chính sách bảo mật
                  </Button>
                </Box>
              </Stack>
            </Stack>
            <Stack direction="row" alignItems="center" justifyContent="center" spacing={2.5}>
              {' '}
              <Stack spacing={2}>
                <Box
                  sx={{
                    width: { md: 225, sm: 180, xs: 120 },
                    height: { md: 127, sm: 100, xs: 80 },
                    backgroundImage: `url('/assets/landing/security/cloudflare.png')`,
                    backgroundSize: 'contain',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'right',
                  }}
                />
                <Typography
                  textAlign="center"
                  variant={smUp ? 'body1' : 'caption'}
                  fontWeight="500"
                >
                  Cloudflare partner
                </Typography>
              </Stack>
              <Stack spacing={2}>
                <Box
                  sx={{
                    width: { md: 225, sm: 180, xs: 120 },
                    height: { md: 127, sm: 100, xs: 80 },
                    backgroundImage: `url('/assets/landing/security/google-cloud-partner.png')`,
                    backgroundSize: 'contain',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'right',
                  }}
                />
                <Typography
                  textAlign="center"
                  variant={smUp ? 'body1' : 'caption'}
                  fontWeight="500"
                >
                  Google cloud partner
                </Typography>
              </Stack>
            </Stack>
          </Stack>
        </Stack>
      </Container>
      {mdUp && (
        <>
          <Box
            position="absolute"
            zIndex={-1}
            left={0}
            bottom={-20}
            sx={{
              backgroundImage: `url(/assets/landing/security/security.svg)`,
              width: { md: '271px', sm: '65px', xs: '40px' },
              height: { md: '298px', sm: '65px', xs: '40px' },
              backgroundSize: 'contain',
              backgroundRepeat: 'no-repeat',
            }}
          />
          <Box
            position="absolute"
            zIndex={-1}
            right={-215}
            bottom={0}
            sx={{
              backgroundImage: `url(/assets/landing/security/security-vector.svg)`,
              width: { md: '555px', sm: '65px', xs: '40px' },
              height: { md: '216px', sm: '65px', xs: '40px' },
              backgroundSize: 'contain',
              backgroundRepeat: 'no-repeat',
            }}
          />
        </>
      )}
    </Box>
  );
};
